import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import { db } from "../../../services/firebase";
import useSWRSubscription from "swr/subscription";
import { FIRESTORE_RECIPES_TABLE } from "../../../constants/FirebaseConstants";

export function useRecipes() {
  const { data } = useSWRSubscription("recipes", (key, { next }) => {
    const q = query(
      collection(db, FIRESTORE_RECIPES_TABLE),
      orderBy("createdAt", "desc"),
    );
    return onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map((doc) => {
        return { ...doc.data(), id: doc.id };
      });
      next(null, data);
    });
  });

  return {
    data,
    loading: !data,
  };
}
